import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
// primereact
import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { BreadCrumb } from "primereact/breadcrumb";
//components
import Panel from "../../../components/panel/panel";
import Select from "../../../components/input/Select";
import ExportTable from "../../../components/button/ExportButton";
//services
import { postReportLands } from "../../../services/Report/postReportLands";
//hooks
import { useAppContext } from "../../../context/AppContext";
import { formatCurrency } from "../../../utils/formatCurrency";
import { useOptionsSelect } from "../../../hooks/useOptionsSelect";
import usePermission from "../../../hooks/usePermission";

export default function Lands() {
  usePermission("131"); //Visualizar Relatorio de Lotes
  const { nomenclatures, permissions } = useAppContext();
  const nomenclature = JSON.parse(nomenclatures);
  const navigate = useNavigate();
  const [visible, setVisible] = useState(false);
  const [loading, setLoading] = useState();
  const [tableData, setTableData] = useState();
  const [tableToExport, setTableToExport] = useState(null);
  const [globalFilterValue, setGlobalFilterValue] = useState("");
  const form = useForm();
  const errors = form.formState.errors;

  const columns = [
    { field: "enterprise", header: "Empreendimento" },
    { field: "block", header: nomenclature[0].value },
    { field: "land", header: nomenclature[1].value },
    { field: "m2", header: "M²" },
    { field: "value", header: "Valor" },
    {
      field: "status",
      header: "Status",
      body: (rowData) => {
        let labelClass = "";
        let labelText = "";
        switch (rowData.status) {
          case 0:
            labelClass = "badge bg-warning";
            labelText = "Reservado";
            break;
          case 1:
            labelClass = "badge bg-success";
            labelText = "Disponível";
            break;
          case 2:
            labelClass = "badge bg-danger";
            labelText = "Vendido";
            break;
          case 3:
            labelClass = "badge bg-secondary";
            labelText = "Bloqueado";
            break;
          default:
        }
        return (
          <span
            className={labelClass}
            style={{
              fontSize: "10px",
              marginRight: "-40px",
            }}
          >
            {labelText}
          </span>
        );
      },
    },
    { field: "num_register", header: "Matrícula" },
    { field: "front_measurement", header: "Frente" },
    { field: "bottom_measurement", header: "Fundo" },
    { field: "left_measurement", header: "Esquerda" },
    { field: "right_measurement", header: "Direita" },
    { field: "corner_measurement", header: "Esquina" },
    { field: "front_confrontation", header: "C. Frente" },
    { field: "bottom_confrontation", header: "C. Fundo" },
    { field: "left_confrontation", header: "C. Esquerda" },
    { field: "right_confrontation", header: "C. Direita" },
    { field: "others_confrontation", header: "C. Outras" },
    { field: "general_confrontation", header: "C. Geral" },
  ];

  const {
    enterprise,
    isLoadingEnterprises,
    blocks,
    isLoadingBlocks,
    selectEnterprise,
  } = useOptionsSelect();

  const exportColumns = columns.map((col) => ({
    title: col.header,
    dataKey: col.field,
  }));

  const onGlobalFilterChange = (e) => {
    setGlobalFilterValue(e.target.value);
  };

  useEffect(() => {
    if (tableData) {
      const formated = tableData.map((item) => {
        return {
          ...item,
          value: formatCurrency(item.value),
        };
      });
      setTableData(formated);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const items = [
    {
      template: () => (
        <Link to={"#"} className="p-breadcrumb-link">
          Confrontações de {nomenclature[1].value}
        </Link>
      ),
    },
  ];
  const home = {
    template: () => (
      <Link to={"#"} className="p-breadcrumb-link">
        <i className="fa fa-home"></i>
      </Link>
    ),
  };

  const status = [
    { label: "Disponível", value: 1 },
    { label: "Vendido", value: 2 },
    { label: "Reservado", value: 0 },
    { label: "Bloqueado", value: 3 },
  ];

  const onSubmit = async (data) => {
    const notification = toast.loading(
      "Por favor aguarde a consulta está sendo realizada..."
    );
    try {
      setLoading(true);
      const response = await postReportLands(data);
      setTableData(response);
      toast.update(notification, {
        render: "Consulta Realizada!",
        autoClose: 1000,
        theme: "colored",
        type: "success",
        isLoading: false,
      });
      setLoading(false);
      setVisible(true);
    } catch (e) {
      toast.update(notification, {
        render: "Houve um erro a buscar os dados, tente novamente",
        type: "error",
        theme: "colored",
        autoClose: 5000,
        isLoading: false,
      });
    }
  };

  useEffect(() => {
    if (tableData) {
      // console.log("tabela", tableData);
      const dataWithoutIds = tableData.map((t) => {
        let labelText = "";
        switch (t.status) {
          case 1:
            labelText = "Disponível";
            break;
          case 2:
            labelText = "Vendido";
            break;
          case 0:
            labelText = "Reservado";
            break;
          case 3:
            labelText = "Bloqueado";
            break;
          default:
            labelText = "Indefinido"; // valor padrão caso não corresponda a nenhum caso
        }
        return {
          Empreendimento: t.enterprise,
          Quadra: t.block,
          Lote: t.land,
          Metragem: t.m2,
          Valor: t.value,
          Status: labelText, // agora com valor correto
          Matricula: t.num_register,
          Frente: t.front_measurement,
          Fundo: t.bottom_measurement,
          Esquerda: t.left_measurement,
          Direita: t.right_measurement,
          Esquina: t.corner_measurement,
          CFrente: t.front_confrontation,
          CFundo: t.bottom_confrontation,
          CEsquerda: t.left_confrontation,
          CDireita: t.right_confrontation,
          COutros: t.others_confrontation,
          CGeral: t.general_confrontation,
        };
      });

      // console.log("sem ids", dataWithoutIds);
      setTableToExport(dataWithoutIds);
    }
  }, [tableData]);

  return (
    <>
      <div className="row d-flex justify-content-between mb-3">
        <div>
          <BreadCrumb
            model={items}
            home={home}
            style={{
              background: "transparent",
              border: "none",
              fontSize: "16px",
            }}
          />
        </div>
        <Panel title={`Relatório de ${nomenclature[1].value}`}>
          <form onSubmit={form.handleSubmit(onSubmit)}>
            <div className="row d-flex mt-4">
              <div className="col-md-4 mb-3 form-group">
                <Select
                  control={form.control}
                  label={
                    isLoadingEnterprises ? "Carregando..." : "Empreendimento"
                  }
                  name="enterprise_id"
                  disabled={isLoadingEnterprises}
                  onChange={(e) => selectEnterprise(e)}
                  options={enterprise}
                  errors={errors}
                />
              </div>
              <div className="col-md-4 mb-3 form-group">
                <Select
                  control={form.control}
                  label={
                    isLoadingBlocks ? "Carregando..." : nomenclature[0].value
                  }
                  name="block_id"
                  options={blocks}
                  errors={errors}
                />
              </div>
              <div className="col-md-4 mb-3 form-group">
                <Select
                  control={form.control}
                  label="Status"
                  name="status"
                  options={status}
                  errors={errors}
                />
              </div>
              <div className="d-flex justify-content-end">
                <div
                  className={`${
                    window.innerWidth <= 992 ? "w-25" : "col-md-1"
                  } text-center`}
                >
                  <Button
                    type="submit"
                    icon="fa fa-search"
                    aria-label="Search"
                    loading={loading}
                    className={`rounded-3 py-2.5 w-100`}
                  />
                </div>
              </div>
            </div>
          </form>
        </Panel>

        {visible && (
          <Panel mainCss="mt-4">
            <>
              {/* <hr className="my-4" /> */}
              <div className="px-2 pb-3">
                <ExportTable
                  tableData={tableToExport}
                  tabelaKey="Relatório de Quadras e Lotes"
                  exportColumns={exportColumns}
                  globalFilterValue={globalFilterValue}
                  onGlobalFilterChange={onGlobalFilterChange}
                />
                <DataTable
                  rows={25}
                  paginator
                  stripedRows
                  showGridlines
                  sortMode="multiple"
                  selectionMode="single"
                  rowsPerPageOptions={[25, 50, 100, 1000]}
                  value={
                    tableData &&
                    tableData.map((item) => {
                      return {
                        ...item,
                        value: formatCurrency(item.value),
                      };
                    })
                  }
                  totalRecords={tableData.length}
                  globalFilter={globalFilterValue}
                  emptyMessage="Nenhuma Informação foi encontrada."
                  tableStyle={{ minWidth: "0.8rem", fontSize: "0.7rem" }}
                >
                  {columns.map((col) => (
                    <Column
                      sortable
                      key={col.field}
                      field={col.field}
                      body={col.body}
                      // style={{ minWidth: 180 }}
                      header={col.header}
                      style={
                        col.field === "general_confrontation"
                          ? { minWidth: "1000px" }
                          : { minWidth: 120 }
                      }
                      // filterMatchMode={FilterMatchMode.CONTAINS}
                    />
                  ))}
                </DataTable>
              </div>
            </>
          </Panel>
        )}
      </div>
    </>
  );
}
